import React from "react";
import { IconButton } from "@/comn/components/IconButton";
import { BOLD_TEXT, COLOR_BORDER, COLOR_TEXT, SIZE_TEXT } from "@/comn/features/foundation";
import { comnUtils } from "@/comn/utils";
import classNames from "classnames";

/** */
export type InputPasswordProps = {
    edit?: boolean;
    mode?: "edit" | "view" | null;

    name?: string;
    value?: any;
    readOnly?: boolean;
    disabled?: boolean;
    maxLength?: number;
    placeholder?: string;
    defaultValue?: any;

    color?: keyof typeof COLOR_TEXT;
    editColor?: keyof typeof COLOR_TEXT;
    borderColor?: keyof typeof COLOR_BORDER;
    bold?: keyof typeof BOLD_TEXT;
    editBold?: keyof typeof BOLD_TEXT;
    fontSize?: keyof typeof SIZE_TEXT;

    onBlur?: (arg?: any) => void;
    onFocus?: (arg?: any) => void;
    onChange?: (arg?: any) => void;

    className?: string;
};

export const InputPassword = React.forwardRef<HTMLInputElement, InputPasswordProps>(
    (props: InputPasswordProps, ref: React.ForwardedRef<HTMLInputElement>) => {
        const {
            /** */
            edit = true,
            mode,
            /** input props */
            name,
            value,
            readOnly,
            disabled,
            maxLength,
            placeholder,
            defaultValue,

            color,
            editColor,
            borderColor,
            bold,
            editBold,
            fontSize,

            onBlur,
            onFocus,
            onChange,

            className,
        } = props;

        const _props = Object.fromEntries(
            Object.entries({
                name,
                readOnly,
                disabled,
                maxLength,
                placeholder,
                defaultValue,
                onBlur,
                onFocus,
            }).filter(([, value]) => value !== undefined),
        );

        const [show, setShow] = React.useState(false);
        const [_value, _setValue] = React.useState<any>(formatPassword(value));

        React.useEffect(() => {
            if (value === _value) return;

            _setValue(formatPassword(value));
        }, [value]);

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const fomrattedValue = formatPassword(e.target.value);
            _setValue(fomrattedValue);

            if (onChange) {
                onChange(fomrattedValue);
            }
        };

        const replacePassword = (value: string) => {
            if (!value) return "*";

            let t = "";

            for (let i = 0; i < value.length; i++) {
                t += "*";
            }
            return t;
        };

        const EDIT_STATUS = mode === "edit" ? true : mode === "view" ? false : edit;

        return (
            <div className="w-full">
                {!EDIT_STATUS && (
                    <div className={classNames("w-fit", comnUtils.getViewStyle(color, bold, fontSize))}>
                        {replacePassword(_value)}
                    </div>
                )}
                <div hidden={!EDIT_STATUS}>
                    <div className="relative flex items-center">
                        <input
                            {..._props}
                            ref={ref}
                            value={_value}
                            onChange={handleChange}
                            type={show ? "text" : "password"}
                            autoComplete="off"
                            className={classNames(
                                "input" + comnUtils.getEditStyle(editColor, editBold),
                                borderColor ? COLOR_BORDER[borderColor] : "",
                                className,
                            )}
                        />
                        <IconButton
                            onClick={() => setShow((prev) => !prev)}
                            icon={show ? "eyeSlash" : "eye"}
                            size="sm"
                            className="absolute right-1"
                        />
                    </div>
                </div>
            </div>
        );
    },
);

export const formatPassword = (v: any) => {
    if (!v) return "";

    let f = String(v);
    // const reg = /[^a-zA-Z0-9@!@#$%^&*()_+;:'"/]/g;
    // return f.replace(reg, "");
    return f;
};

export const unformatPassword = (v: any) => {
    if (!v) return undefined;

    return String(v);
};
